import type { FaireProductEntity } from "../../entity_types/product";

export const p_vpnd3gf2p2: FaireProductEntity = {
  token: "p_vpnd3gf2p2",
  type: "product",
  name: "18K STAINLESS STEEL WATERPROOF TARNISH FREE HOOPS | 40E405",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/d0cf141bdee08ead3da32063e9e26d1584954421bdbdabad561e7a328a424198.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf0ddb6bc38725dce796cb1f2d47d827835786d818329f3164135f78721b14a0.jpeg",
    "https://cdn.faire.com/fastly/ccaead786dd57f6c58508b39d53898e49c04f443487608b73833c50380f1a9a7.jpeg",
    "https://cdn.faire.com/fastly/f3eb154f325febd314a39e6b4617045a22237279931249178b4d9d5313c8ea20.jpeg",
    "https://cdn.faire.com/fastly/ee0c14f1a203f8afcb4e20188e5cea4818a3db68fda4911e2b47e4b7b6f75e4e.jpeg",
    "https://cdn.faire.com/fastly/8ddcd5b696bfa6442dfd4e9cc955a90c8d11873d5b3474f57819513393de2e97.jpeg",
  ],
  priceDollars: 6.86,
  description:
    '18K Stainless Steel Waterproof Tarnish-Free bubble square Huggie Hoop Earrings, Made from high-quality stainless steel with a luxurious 18K gold finish, these earrings feature a stunning high end puffy square hoop that adds depth and dimension to your look. \n\nProduct Details:\nlength: 1"\nwidth: 1"                            \nearring back:  Stainless Steel Post\nmetal finish: 18K Stainless Steel\nproduct:  Lead & Nickel Compliant\ndurability:  tarnish free, non-tarnish\n\nReal Gold Dipped Earrings\nStainless Steel Earrings \nHypoallergenic Earrings\nTarnish-Free Earrings \nNon-Tarnish Earrings\nWaterproof Earrings \nWater Resistant Earrings\nSweatproof Jewelry\nFade Resistant Earrings \nAnti-oxidation \nLasting Shine ',
  tags: [],
  msrpDollars: 13.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:28.890Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
